var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-12"}),_c('NavigationDrawer'),_c('router-view'),_c('div',{staticClass:"footer footer-fixed-bottom"},[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }